import API from './api';

export default class NetworkAffiliatePreferenceApi {
  static create(affiliateId, params) {
    return API.post(`/advertisers/affiliates/${affiliateId}/preferences`, params);
  }
}
